export default __webpack_public_path__ + "static/media/EP22_ERYTHREE.e7d4cac5.mp3";